import React, { useState, useEffect, useRef } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import uuid from 'react-uuid';
import { Formik } from 'formik';
import ReferenceForm from '../ReferenceForm';
import WarningNotiifcation from 'components/WarningNotification';
import { connect } from 'react-redux';
//import ReCAPTCHA from 'react-google-recaptcha';
import { SetLoading } from "redux/actions/loadingActions";
import { SetUser } from "redux/actions/userActions";
import { updateMany } from 'services';
import { get } from 'services';
import { isBrowser } from 'react-device-detect';
import { SetOperationSuccess  } from "redux/actions/operationSuccessActions";
import { SetHasRefenceData } from "redux/actions/hasReferenceDataActions";
import Spinner from 'react-bootstrap/Spinner';
import { useHistory } from "react-router";

let yup = require('yup');
const Swal = require('sweetalert2');

const ReferenceFormWrapper = ({ user, SetLoading, SetOperationSuccess, opeationSuccess, SetHasRefenceData, hasReferenceDataReducer }) => {
    const [totalReferenciasLaborales, setTotalReferenciasLaborales] = useState(0);
    const [TotalReferenciasPersonales, setTotalReferenciasPersonales] = useState(0);
    const [referenceForm, setReferenceForm] = useState([]);
    //const [reCAPTCHA, setReCAPTCHA] = useState('');
    const [loadForm, setLoadForm] = useState(false);
    const [formContent, setFormContent] = useState({});
    const [formikSchema, setFormikSchema] = useState({});
    const [basicSchema, setBasicSchema] = useState({});
    const [referenceTypeArr, setReferenceTypeArr] = useState([]);
    const formRef = useRef();
    //const reRef = useRef();
    const [saveAndContinue, setSaveAndContinue] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();

    useEffect(() => {
        (async function mounted() {
            const response = await get(`PersonaReferencia/GetByPersonaId/${user.persona.id}`);
            user.persona.personaReferencias = response.data;
            
            if (user.persona.personaReferencias && user.persona.personaReferencias.length > 0) {
                user.persona.personaReferencias = user.persona.personaReferencias.filter(x => x);
                let schema = {};
                let values = {};
                let referencias = [];
                user.persona.personaReferencias.forEach(referencia => {
                    const referenciaId = referencia.id;
                    schema = {
                        ...schema,
                        [`referenceType_${referenciaId}`]: yup.number().required("El campo es requerido"),
                        [`names_${referenciaId}`]: yup.string().matches(/^[A-Za-zá-ýÁ-Ý\s]*$/, 'Debe ingresar solo carácteres alfabéticos').required("El campo es requerido"),
                        [`lastNames_${referenciaId}`]: yup.string().matches(/^[A-Za-zá-ýÁ-Ý\s]*$/, 'Debe ingresar solo carácteres alfabéticos').required("El campo es requerido"),
                        //[`position_${referenciaId}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
                        [`phone_${referenciaId}`]: yup.string().required("El campo es requerido"),
                        [`company_${referenciaId}`]: yup.string(),
                        [`parentescoId_${referenciaId}`]: yup.number().required("El campo es requerido").typeError("El campo es numérico"),
                    };
                    values = {
                        ...values,
                        [`referenceType_${referenciaId}`]: referencia.laboral,
                        [`names_${referenciaId}`]: referencia.nombre,
                        [`lastNames_${referenciaId}`]: referencia.apellido,
                        //[`position_${referenciaId}`]: referencia.profesionId,
                        [`parentescoId_${referenciaId}`]: referencia.parentescoId,
                        [`phone_${referenciaId}`]: referencia.telefono,
                        [`company_${referenciaId}`]: referencia.empresaReferencia,
                    };
                    referencias.push({
                        id: referenciaId,
                        estado: referencia.estado,
                        isNew: false,
                        tipo: referencia.laboral
                    })
                });
                setBasicSchema(() => {
                    return schema;
                });
                updateFormik(schema);
                setFormContent(() => {
                    return values
                });
                setReferenceForm(() => {
                    return [
                        ...referencias
                    ];
                });
            }
            setReferenceTypeArr(() => {
                return [{ value: '', label: 'Seleccione...' }, { value: 1, label: 'Laboral' }, { value: 0, label: 'Personal' }]
            });
            setLoadForm(true);
        })();
    }, [])
    
    useEffect(() => {
        if (loadForm) {
            if (user.persona.personaReferencias && user.persona.personaReferencias.length == 0 || user.persona.personaReferencias.every(x => x.estado == 0)) {
                onAddreferenceForm();
            }
        }
    }, [loadForm]) 

    const updateFormik = (schema) => setFormikSchema(() => {
        return yup.object(schema);
    });

    const onSaveAndContinue = () => {
        formRef.current.validateForm().then(data => {
            if (Object.keys(data).length === 0 && data.constructor === Object) {
                setSaveAndContinue(true);
                formRef.current.handleSubmit();
            }
        })
    }

    const onSave = () => {
        formRef.current.validateForm().then(data => {
            if (Object.keys(data).length === 0 && data.constructor === Object) {
                setSaveAndContinue(false);
                formRef.current.handleSubmit();
            }
        })
    }

    const onExit = () => {
        history.push({
            pathname: "/reference",
            state: {
                updateUserData: true
            }
        });
    }

    const onAddreferenceForm = () => {
        const guid = uuid();
        const oldValues = formRef.current.values;

        const newSchema = {
            ...basicSchema,
            [`referenceType_${guid}`]: yup.number().required("El campo es requerido"),
            [`names_${guid}`]: yup.string().matches(/^[A-Za-zá-ýÁ-Ý\s]*$/, 'Debe ingresar solo carácteres alfabéticos').required("El campo es requerido"),
            [`lastNames_${guid}`]: yup.string().matches(/^[A-Za-zá-ýÁ-Ý\s]*$/, 'Debe ingresar solo carácteres alfabéticos').required("El campo es requerido"),
            //[`position_${guid}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
            [`parentescoId_${guid}`]: yup.number().required("El campo es requerido").typeError("El campo es numérico"),
            [`phone_${guid}`]: yup.string().required("El campo es requerido"),
            [`company_${guid}`]: yup.string(),
        };

        setBasicSchema(() => {
            return newSchema;
        });
        
        setFormContent(() => {
            return {
                ...oldValues,
                [`referenceType_${guid}`]: '',
                [`names_${guid}`]: '',
                [`lastNames_${guid}`]: '',
                //[`position_${guid}`]: '',
                [`parentescoId_${guid}`]: '',
                [`phone_${guid}`]: '',
                [`company_${guid}`]: '',
            }
        });
        
        setReferenceForm(() => {
            return [
                ...referenceForm,
                {
                    id: guid,
                    estado: 1,
                    isNew: true,
                }
            ];
        });
        
        updateFormik(newSchema);
    };

    const onRemovereferenceForm = (identifier) => {
        let newSchema = basicSchema;
        const oldValues = formRef.current.values;
        const removedForm = referenceForm.find(x => x.id === identifier);

        const schemaKeys = [
            `referenceType_${identifier}`,
            `names_${identifier}`, 
            `lastNames_${identifier}`, 
            //`position_${identifier}`,
            `parentescoId_${identifier}`,
            `phone_${identifier}`, 
            `company_${identifier}`, 
        ];

        schemaKeys.forEach(key => {
            delete newSchema[key]
            delete oldValues[key]
        });

        setBasicSchema(() => {
            return newSchema;
        });

        setFormContent(() => {
            return oldValues
        });
        
        updateFormik(newSchema);

        if (removedForm.isNew) {
            setReferenceForm(() => {
                return [
                    ...referenceForm.filter(x => x.id !== identifier)
                ]
            })
        } else {
            removedForm.estado = 0;
            setReferenceForm(() => {
                return [
                    ...referenceForm
                ]
            })
        }
        calculateReferences();
    };

    const onFormSubmitted = async (form) => {
        let personaReferencias = [];
        const symbols = ['(', ')', '-', ' '];
        referenceForm.forEach(referencia => {
            const nombre = referencia.estado == 0
                ? user.persona.personaReferencias.find(x => x.id == referencia.id)?.nombre
                : form['names_' + referencia.id];
            const apellido = referencia.estado == 0
                ? user.persona.personaReferencias.find(x => x.id == referencia.id)?.apellido
                : form['lastNames_' + referencia.id];
            const empresaReferencia = referencia.estado == 0
                ? user.persona.personaReferencias.find(x => x.id == referencia.id)?.empresaReferencia
                : form['company_' + referencia.id];   
            let telefono = referencia.estado == 0
                ? user.persona.personaReferencias.find(x => x.id == referencia.id)?.telefono
                : form['phone_' + referencia.id];   
            const laboral = Number(referencia.estado == 0
                ? user.persona.personaReferencias.find(x => x.id == referencia.id)?.laboral
                : form['referenceType_' + referencia.id]);  

            // const profesionId = Number(referencia.estado == 0
            //     ? user.persona.personaReferencias.find(x => x.id == referencia.id)?.profesionId
            //     : form['position_' + referencia.id]);  

            const parentescoId = Number(referencia.estado == 0
                ? user.persona.personaReferencias.find(x => x.id == referencia.id)?.parentescoId
                : form['parentescoId_' + referencia.id]);  
            
            symbols.forEach(symbol => {
                telefono = telefono.replace(symbol, '');
            });
            const personaReferencia = {
                id: referencia.isNew ? null : referencia.id,
                nombre,
                apellido,
                empresaReferencia,
                telefono,
                laboral,
                //profesionId,
                parentescoId,
                personaId: user.persona.id,
                estado: referencia.estado,
            }
            personaReferencias.push(personaReferencia);
        });
        try {
            setIsLoading(true);
            const response = await updateMany('PersonaReferencia', personaReferencias);
            user.persona = {
                ...user.persona,
                personaReferencias: [
                    ...response.data
                ]
            }
            SetUser(user);
            localStorage.setItem('currentUser-ARS', JSON.stringify(user));
            SetOperationSuccess(opeationSuccess + 1)

            if (response && response.data && response.data.some(x => x.estado == 1)) {
                SetHasRefenceData(true);
            } else {
                SetHasRefenceData(false);
            }

            const route = saveAndContinue ? "/jobAppliedInformation" : "/reference";
            history.push({
                pathname: route,
                state: {
                    updateUserData: true
                }
            });

        } catch (error) {
            console.log(error)
            Swal.fire({
                icon: 'warning',
                title: 'Atención',
                text: '¡Favor intente nuevamente!'
            })
        } finally {
            setIsLoading(false);
        }
    };

    const calculateReferences = () => {
        let totalLaboral = 0;
        let totalPersonal = 0;
        referenceForm.forEach(reference => {
            if (formRef.current.values['referenceType_' + reference.id] !== "" && reference.estado == 1) {
                if (formRef.current.values['referenceType_' + reference.id] == 1) {
                    totalLaboral++;
                } else if (formRef.current.values['referenceType_' + reference.id] == 0)  {
                    totalPersonal++;
                }
            }
        });
        setTotalReferenciasLaborales(totalLaboral)
        setTotalReferenciasPersonales(totalPersonal)
    }

    return (
        <>
            {
                isLoading &&
                <div className={'display-flex flex-direction-row flex-center'}>
                    <Spinner 
                        animation="grow" 
                        variant="primary" 
                        className={'is-absolute center-spinner-vertically'} 
                        size="lg" />
                </div>
            }
            <Card>
                <Card.Body className={'p-40'}>
                    {
                        loadForm &&
                        <div>
                            <Formik
                                innerRef={formRef}
                                validationSchema={formikSchema}
                                onSubmit={onFormSubmitted}
                                initialValues={formContent}
                                enableReinitialize={true}
                                validateOnChange={false}
                                validateOnBlur={false}
                            >
                                {({
                                    handleSubmit,
                                    handleChange,
                                    handleBlur,
                                    values,
                                    touched,
                                    isValid,
                                    errors,
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <Form.Row>
                                            <Form.Group as={Col} md="12" className="mb-0">
                                                <div className={'display-flex space-between'}>
                                                    <div style={{fontSize:18}}>
                                                        <b> Campos obligatorios * </b>
                                                    </div>
                                                    {
                                                        // isBrowser &&
                                                        // <div style={{fontSize:20}}>
                                                        //     <b> Referencias: </b> { totalReferenciasLaborales + TotalReferenciasPersonales }/3  laborales o personales
                                                        // </div>
                                                    }
                                                </div>
                                            </Form.Group>
    
                                            <Form.Group as={Col} md="12" className="mb-25">
                                                <span style={{fontSize: 18}}> 
                                                    Agradecemos coloques un mínimo de tres (3) referencias laborales de anteriores empleadores, iniciando con el más reciente. Los contactos deben ser de quien te supervisaba directamente o del máximo representante del área donde desempeñaste tus funciones.
                                                    <br/>
                                                    Si es tu primer empleo o no tienes un máximo de tres (3) referencias laborales puedes completarlo con referencias personales que no sean familiares ni antiguos empleadores.
                                                </span>
                                            </Form.Group>
                                            
                                            {
                                                referenceForm.length > 0 ? 
                                                referenceForm.filter(x => x.estado == 1 && `names_${x.id}` in values).map((element) => {
                                                    return <ReferenceForm 
                                                        key={element.id} 
                                                        handleChange={handleChange} 
                                                        errors={errors} 
                                                        touched={touched} 
                                                        values={values} 
                                                        element={element}
                                                        removeReferenceForm={onRemovereferenceForm}
                                                        options={referenceTypeArr} 
                                                        onReferenceTypeChange={calculateReferences}
                                                    />
                                                })
                                                : 
                                                <Form.Group as={Col} md="12">
                                                    <WarningNotiifcation message='No ha agregado formularios a la sección ' enphasis={'Referencias'}/>
                                                </Form.Group>
                                            }
                                            <Form.Group as={Col} md="12">
                                                <div className={'display-flex flex-end'}>
                                                    <Button onClick={onAddreferenceForm}> Agregar </Button>
                                                </div>
                                            </Form.Group>
                                        </Form.Row>
                                        
                                        {
                                            referenceForm.length > 0 && 
                                            <Form.Group className={'display-flex space-between padding-right-0'}  as={Col} md="12">
                                                {
                                                    hasReferenceDataReducer 
                                                    ? <Button size="medium" variant="light" onClick={onExit}> <b> Cancelar edición </b> </Button>
                                                    : <div> </div>
                                                }
                                                <div>
                                                    <Button size="medium" type="button" onClick={onSave}> <b> Guardar </b> </Button>
                                                    <Button className={'margin-left-5'} size="medium" type="button" onClick={onSaveAndContinue}> <b> Guardar y continuar </b> </Button>
                                                </div>
                                            </Form.Group>
                                        }
                                        
                                    </Form>
                                    )}
                            </Formik>
                        </div>
                    }
                </Card.Body>
            </Card>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
        opeationSuccess: state.opeationSuccess,
        hasReferenceDataReducer: state.hasReferenceDataReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        SetUser: (user) => dispatch(SetUser(user)),
        SetLoading: (value) => dispatch(SetLoading(value)),
        SetOperationSuccess: (value) => dispatch(SetOperationSuccess(value)),
        SetHasRefenceData: (value) => dispatch(SetHasRefenceData(value)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ReferenceFormWrapper);